export const boxStyle = {
  borderRadius: 6,
  width: '50%',
  padding: 5,
  boxSizing: 'border-box',
  lineHeight: '1.5714285714285714',
  backgroundColor: '#ffffff',
  border: '1px solid #f0f0f0',
  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
  cursor: 'pointer',
};
export const loadingOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};
